export const LAYERDOWNLOAD_FORMAT_OPTIONS_FETCH = "LAYERDOWNLOAD:FORMAT_FETCH";
export const LAYERDOWNLOAD_FORMAT_OPTIONS_UPDATE = "LAYERDOWNLOAD:FORMAT_UPDATE";